import { Stack } from "@mui/system";
import { ReactNode, useState } from "react";
import { CircularProgress } from "@mui/material";
import { ButtonsColorType, ButtonsType } from "../../../../types/enums";
import { ReuseButton } from "../../ReuseButton";

type Props = {
  btnText: string;
  isGradient?: boolean;
  renderModal: (props: {
    isOpen: boolean;
    onClose: () => void;
    setIsLoading: (value: boolean) => void;
  }) => ReactNode;
  isDisabled?: boolean;
};

export const OpenModalButton = ({
  btnText,
  renderModal,
  isGradient,
  isDisabled,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack gap="24px">
      {isGradient ? (
        <ReuseButton
          onClick={() => setIsOpen(true)}
          buttonColor={ButtonsColorType.gradient}
          buttonType={ButtonsType.contained}
          disabled={isLoading || isDisabled}
        >
          {btnText}
        </ReuseButton>
      ) : (
        <ReuseButton
          onClick={() => setIsOpen(true)}
          buttonColor={ButtonsColorType.dark_orange}
          disabled={isLoading || isDisabled}
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {btnText}
        </ReuseButton>
      )}

      {isOpen &&
        renderModal({
          isOpen,
          onClose: () => setIsOpen(false),
          setIsLoading,
        })}
    </Stack>
  );
};
